import { Injectable, ErrorHandler } from '@angular/core';
import { SocketService } from 'projects/game-utils/src/lib/service/socket.service';
import { WarcabyGameService } from './warcaby-game.service';
import { Message } from 'projects/game-utils/src/lib/utils/Message';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeEvent } from 'projects/game-utils/src/lib/events/ChangeEvent';
import { GlobalEventEmitterService } from 'projects/game-utils/src/lib/service/global-event-emitter.service';
import { ErrorToSend } from 'projects/game-utils/src/lib/utils/ErrorToSend';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler{

  private user:string;
  private static errorWindowShown:boolean = false;

  setErrorWindowShown(error:boolean):void{
    ErrorHandlerService.errorWindowShown = error;
  }
  constructor(private gameService:WarcabyGameService, private socketService:SocketService, private  httpClient:HttpClient) { }

  showErrorWindow( error:any ):void{
    if( !ErrorHandlerService.errorWindowShown ){
      ErrorHandlerService.errorWindowShown = true;
      let finishWindowMsg:Message = new Message();
      finishWindowMsg.name = "SHOW_HIDE_WINDOW";
      finishWindowMsg.params = new Array();
      finishWindowMsg.params[0] = "ErrorWindow";
      finishWindowMsg.params[1] = "true";

      finishWindowMsg.params[2] = "";
      finishWindowMsg.params[3] = "";

      finishWindowMsg.params[4] = "msg";
      finishWindowMsg.params[5] = error.message;

      let change:ChangeEvent = new ChangeEvent("changeEvent", finishWindowMsg);
      change.windowParams = finishWindowMsg.params;
      GlobalEventEmitterService.globalEmitter.emit( change );   
    }
  }

  public sendError(error:any):void{
    try{
      if( error.message != "Connection closed" ){
        let errorHttp:string = this.socketService.flashvars.webProtocol + "://" + this.socketService.flashvars.address + ":" + this.socketService.flashvars.httpport + "/server/errors/save-error-js";
        var er:ErrorToSend = new ErrorToSend("-1", name, error.message, error.stack, this.socketService.flashvars.login );
        let header = {
          headers: new HttpHeaders({
            'Content-Type' : 'application/x-www-form-urlencoded',
            'Accept' : 'application/x-www-form-urlencoded'
          })
        };
        this.httpClient.post(errorHttp, er, header).subscribe( (resp) => {
        });
      }
    }catch( e ){
      console.error( e );      
    }
  }

  handleError(error) {
    console.error( error);
    
    this.showErrorWindow(error);

    try{
      this.socketService.close();
    }catch(e){
      console.error(e);
    }
    
    this.sendError( error );
  }

}
